// extracted by mini-css-extract-plugin
module.exports = {"AwesomeLists":"AwesomeLists_AwesomeLists__1huAZ"};